import React, { useMemo } from "react";
import { Spin } from "antd";
import styles from "./RelatedConceptsPanel.module.scss";

const TOP_N = 20;

const RelatedConceptsPanel = ({
  items = [],
  loading = false,
  error = null,
  onConceptClick,
}) => {
  const topItems = useMemo(() => {
    const sorted = [...items].sort(
      (a, b) => (Number(b?.score) || 0) - (Number(a?.score) || 0)
    );
    return sorted.slice(0, TOP_N);
  }, [items]);

  return (
    <section className={styles.card} aria-labelledby="related-concepts-title">
      <h3
        id="related-concepts-title"
        className={styles.title}
        data-report-strip="true"
      >
        Related concepts
      </h3>

      {loading ? (
        <div className={styles["chips-region"]}>
          <div className={styles.loading}>
            <Spin size="small" />
          </div>
        </div>
      ) : error ? (
        <div className={styles["chips-region"]}>
          <p className={styles.error} role="alert">
            Unable to load related concepts.
          </p>
        </div>
      ) : topItems.length === 0 ? (
        <div className={styles["chips-region"]}>
          <p className={styles.empty}>No related concepts for this selection.</p>
        </div>
      ) : (
        <div
          className={styles["chips-region"]}
          aria-label="Top related concepts. Click a chip to add it as a research topic."
        >
          <div className={styles.chips} role="list">
            {topItems.map((item, idx) => {
              const label = (item?.value || "").trim();
              if (!label) return null;
              const key = item?.id != null ? String(item.id) : `${label}-${idx}`;
              return (
                <button
                  key={key}
                  type="button"
                  className={styles.chip}
                  onClick={() => onConceptClick?.(label)}
                  title={label}
                >
                  <span className={styles["chip__text"]}>{label}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
};

export default RelatedConceptsPanel;
